import { GetReservationProviderSelectListActionTypes, GetReservationProviderSelectListState, GET_RESERVATION_PROVIDER_SELECT_LIST_FAILURE, GET_RESERVATION_PROVIDER_SELECT_LIST_REQUEST, GET_RESERVATION_PROVIDER_SELECT_LIST_SUCCESS } from './types';

const defaultState: GetReservationProviderSelectListState = {
  isLoading: false,
  errorMessage: ''
};

export default function getReservationProviderSelectList(state = defaultState, action: GetReservationProviderSelectListActionTypes): GetReservationProviderSelectListState {
  switch (action.type) {
    case GET_RESERVATION_PROVIDER_SELECT_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_RESERVATION_PROVIDER_SELECT_LIST_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ''
      };
    case GET_RESERVATION_PROVIDER_SELECT_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ''
      };
    default:
      return state;
  }
};